import { Controller } from "@hotwired/stimulus"

export default class NavigationController extends Controller {
  static targets = ["userMenu", "mobileMenu"]

  connect() {
    // Close dropdowns when clicking outside
    document.addEventListener('click', this.closeOnClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnClickOutside.bind(this))
  }

  toggleUserMenu(event) {
    event.stopPropagation()
    this.userMenuTarget.classList.toggle('hidden')
  }

  toggleMobileMenu(event) {
    event.stopPropagation()
    this.mobileMenuTarget.classList.toggle('hidden')
    
    // Toggle menu icons
    const button = event.currentTarget
    const menuIcon = button.querySelector('svg:first-child')
    const closeIcon = button.querySelector('svg:last-child')
    
    menuIcon.classList.toggle('hidden')
    closeIcon.classList.toggle('hidden')
  }

  closeOnClickOutside(event) {
    // Close user menu if click is outside
    if (this.hasUserMenuTarget && !this.userMenuTarget.contains(event.target) && 
        !event.target.closest('[data-action*="navigation#toggleUserMenu"]')) {
      this.userMenuTarget.classList.add('hidden')
    }
  }
}
